
import { Options, Vue } from 'vue-class-component';
import ModalBox from '@/shared/components/modal-box/index.vue';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EeSignUpForm } from '@/shared/modules/typescript-trustapi-client/models';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { Inject, Prop } from 'vue-property-decorator';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { TrustAPI } from '@/shared/modules/trust-api';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';

@Options({
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator
  },
  mixins: [FormatDateTimeMixin]
})
export default class ApproveRejectToBeEEModal extends Vue {

  @Prop({ default: -1})
  private actionType!: number;


  @Prop({ default: {}})
  private eeSignUpForm!: EeSignUpForm;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private loadingContent = false;
  private submitting = false;

  private selectedEESignUpForm: EeSignUpForm = {};

  created(): void {
    this.getSignUpForm();
  }

  private async getSignUpForm(): Promise<void> {
    try {
      this.loadingContent = true;
      const result = await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminGetEeSignUpFormByIdEeSignUpFormIdGet(this.eeSignUpForm.id);
      this.selectedEESignUpForm = result?.data.data as EeSignUpForm;
    } catch {
      this.eventCtrl.emit('show-snackbar', 'error', 'Problems loading External Examiner Sign Up Form');
    } finally {
      this.loadingContent = false; 
    }
  }

  private mainActionButClicked(): void {
    if (this.actionType == 1) {
      this.approveToBeEE();
    } else if (this.actionType == 2) {    
      this.rejectToBeEE();
    }
  }

  private async approveToBeEE(): Promise<void> {
    try {
      this.submitting = true;
      await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminApproveEeSignUpFormEeSignUpFormIdPut(this.eeSignUpForm.id);
      this.eventCtrl.emit('reload-ee-signup-forms');
      this.eventCtrl.emit('show-snackbar', 'success', 'External Examiner Sign Up Form Approved Successfully');
      this.$emit('close');
    } catch{
      this.eventCtrl.emit('show-snackbar', 'error', 'Problems approving External Examiner Sign Up Form');
    } finally {
      this.submitting = false;
    }
  }

  private async rejectToBeEE(): Promise<void> {
    try {
      this.submitting = true;
      await this.apiService.ExternalExaminerApi?.apiV2ExternalExaminerAdminRejectEeSignUpFormEeSignUpFormIdPut(this.eeSignUpForm.id);
      this.eventCtrl.emit('reload-ee-signup-forms');
      this.eventCtrl.emit('show-snackbar', 'success', 'External Examiner Sign Up Form Rejected Successfully');
      this.$emit('close');
    } catch{
      this.eventCtrl.emit('show-snackbar', 'error', 'Problems rejecting External Examiner Sign Up Form');
    } finally {
      this.submitting = false;
    }
  }

  private async downloadFile(file: any): Promise<void> {

    try {
      const resp: any = await this.apiService.FileAtcsApi?.apiV2FileAtcsAdminDownloadStreamFileIdGet(
        file.id,
        { responseType: 'blob' }
      );
      // console.log(resp);
      const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
      const documentURL = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      const fileName = file.fileName;
      downloadLink.href = documentURL;
      downloadLink.download = fileName;
      downloadLink.click();
    } catch (err) {
      console.log(err);
    }
  }



  private closeModal(): void {
    if (!this.submitting || !this.loadingContent) {
      this.$emit('close');
    }
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

}

